<script>
    import { createEventDispatcher } from 'svelte';
    import AuthService from '../services/auth.service.js';

    export let menus, options, params;
    const dispatch = createEventDispatcher();
    //Set menu report option selected to add active class and get submenus
    function selectMenu(menu){
        options.menu = menu;
        options.subMenu = menu.default.replace("/", "");
    }

    const INSIGHT_DASHBOARD_LINKS = {
        internal: 'https://riverside.okta.com/login/login.htm?fromURI=%2Fhome%2Ftableauonline%2F0oa1cjypx8giO8Zih0h8%2F53311',
        external: 'https://sso.online.tableau.com/public/idp/SSO'
    };

    $:selectedUsers = [];
</script>

<div id="reports-panel" class="row">
    <div id="reports-menus" class="col-md-12 d-flex justify-content-center">
        {#each menus as menu}
            {#if (menu.url != "hr") || (menu.url == "hr" && AuthService.canShow('HR', options.org.id))}
                <a on:click={ () => selectMenu(menu) }
                    href="/{menu.url}/{options.org.id}{menu.default}/{options.year}/{options.month}"
                    class="btn btn-default text-center pt-1 d-flex align-items-center report-menu {(menu.url == 'hr')? 'mr-1': ''} {options.menu && options.menu.url == menu.url ? 'active' : ''} { (menu.input && (options.menu && options.menu.url == menu.url) ) ? 'bg-input' : '' }">
                    <div  class="section-title btn-block">{menu.title}</div>
                </a>
                {#if menu.url === 'sdr' }
                <!-- Add insight dashboards tab after SDR tab / report -->
                <a
                    href="{ AuthService.can('ACCESS_INTERNAL_RIVERSIDE') ? INSIGHT_DASHBOARD_LINKS.internal : INSIGHT_DASHBOARD_LINKS.external }"
                    target="_blank"
                    class="btn btn-default text-center pt-1 d-flex align-items-center report-menu"
                >
                    <div  class="section-title btn-block">Insights Dashboards</div>
                </a>
                {/if}
            {/if}
        {/each}
    </div>

    {#if options.menu}
        <div id="reports-sub-menus" class="col-md-12 d-flex justify-content-center">
            {#each options.menu.subMenus as subMenu}
                {#if options.menu.url != "hr" || subMenu.url != 'staffing-agregate' || AuthService.can('SHOW_STAFFING_AGGREGATE') && options.url != "charts"}
                    <a on:click={ () => options.subMenu = subMenu.url }
                    href="/{options.menu.url}/{(params && params.org) ? params.org : options.org.id}/{subMenu.url}/{options.year}/{options.month}"
                    class="btn btn-default text-center pt-1 d-flex align-items-center report-sub-menu {options.subMenu == subMenu.url ? 'active' : ''} { subMenu.input ? 'bg-input' : '' }">
                        <div class="section-title btn-block">{subMenu.title}</div>
                    </a>
                {:else if options.menu.url == "charts"}
                    <a on:click={ () => options.subMenu = subMenu.url }
                    href="/{options.menu.url}/{(params && params.org) ? params.org : options.org.id}/{subMenu.url}/{options.year}/{options.month}"
                    class="btn btn-default text-center pt-1 d-flex align-items-center report-sub-menu {options.subMenu == subMenu.url ? 'active' : ''} { subMenu.input ? 'bg-input' : '' }">
                        <div class="section-title btn-block">{subMenu.title}</div>
                    </a>
                {/if}
            {/each}
        </div>
    {/if}
</div>
